import { ssm_getcookie } from "../../common/utils/ssm_util";
import { fetchAPI } from "../config";

export async function cardPay(obj) {
  let jsonstr = JSON.stringify(obj);
  let sid = ssm_getcookie("ssm_sid");
  const para = { jsonstr, sid };
  const data = await fetchAPI("/ssm_api_store/ccpay", para);
  return data;
}
